module.exports = __webpack_public_path__ + "566c2f650b1940e2eae436fae23bb9d2.pdf";